import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'cccisd-footer';
import NavBar from 'js/components/NavBar';
import { Nav as SecondaryNav } from 'cccisd-laravel-appdefs';
import { isIE } from 'js/utils.js';
import style from './style.css';

const AppDefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

export default class FixedLayout extends React.Component {
    static propTypes = {
        showSecondaryNav: PropTypes.bool,
        children: PropTypes.node,
    };

    static defaultProps = {
        showSecondaryNav: true,
    };

    render() {
        return (
            <div className={style.body}>
                <div className={style.content}>
                    <NavBar className="container" />
                    {this.props.showSecondaryNav && Fortress.auth() && (
                        <div style={{ marginTop: '-0.5em' }}>
                            <SecondaryNav
                                className="container"
                                navs={AppDefs.navs}
                                routes={AppDefs.routes}
                                isInverse
                            />
                        </div>
                    )}
                    <div className="container" style={{ marginTop: '1em' }}>
                        {this.props.children}
                    </div>
                </div>
                {!isIE() && (
                    <div className={style.footer}>
                        <Footer className="container" showContactUsLink={false} />
                    </div>
                )}
            </div>
        );
    }
}
